export interface IScorecardPreviewAPIResponse {
  results: IScorecardPreview[];
}

export interface IScorecardPreview {
  scoredDate: string;
  scorecardId: number;
  scorecardName: string;
  routingUniqueId: string;
  scoreAchieved: number;
  totalPossiblePoints: number;
  version: string;
  disqualified: boolean;
}

export class ScorecardPreviewModel implements IScorecardPreview {
  scoredDate: string = '';
  scorecardId: number = 0;
  scorecardName: string = '';
  routingUniqueId: string = '';
  scoreAchieved: number = 0;
  totalPossiblePoints: number = 0;
  version: string = '';
  disqualified: boolean = false;

  constructor(data?: IScorecardPreview) {
    this.scoredDate = data?.scoredDate ?? this.scoredDate;
    this.scorecardId = data?.scorecardId ?? this.scorecardId;
    this.scorecardName = data?.scorecardName ?? this.scorecardName;
    this.routingUniqueId = data?.routingUniqueId ?? this.routingUniqueId;
    this.scoreAchieved = data?.scoreAchieved ?? this.scoreAchieved;
    this.totalPossiblePoints = data?.totalPossiblePoints ?? this.totalPossiblePoints;
    this.version = data?.version ?? this.version;
    this.disqualified = data?.disqualified ?? this.disqualified;
  }
}
